import React from 'react'
import { Account } from '@ally/data-types-afg-accounts'
import MobileCardDetail from './MobileCardDetail'
import MobileCardDetailFooter from './MobileCardDetailFooter'
import { getWarningMessage } from '../../CreditCard/TableColumns'
import { StyledAccountDetailsLink } from './MobileDepositAccountList'

const MobileCreditCardsList: React.FC<{
  accounts: Account[]
}> = ({ accounts }) => {
  return (
    <>
      {accounts.map((account: Account) => {
        const key = `detail-${account.id}`
        const content = <MobileCardDetail account={account} />

        return (
          <>
            <StyledAccountDetailsLink
              account={account}
              text={content}
              key={key}
            />
            <MobileCardDetailFooter message={getWarningMessage(account)} />
          </>
        )
      })}
    </>
  )
}

export default MobileCreditCardsList
